import React, { Component } from 'react';
import { Container } from 'reactstrap';
//import  Footer  from './Footer';
import loaderImage from '../images/loader.svg'
import  NavHeader  from './NavHeader';

export class CommonLayout extends Component {
    static displayName = CommonLayout.name;

    constructor(props) {
        super(props);
        this.state = {
            zoomMessageVisible: false
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize(); // Initial check for zoom level
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const zoomLevel = window.innerWidth / window.outerWidth;
        if (zoomLevel !== 1) {
            // Show message if zoom level is not 100%
            this.setState({ zoomMessageVisible: true });
        } else {
            // Hide message if zoom level is 100%
            this.setState({ zoomMessageVisible: false });
        }
    };


    render() {
        const { zoomMessageVisible } = this.state;
        return (
            <div className="ltr light-theme horizontalmenu-hover horizontalmenu color-menu header-light">
                {/*{zoomMessageVisible && (*/}
                {/*    <h6 style={{ backgroundColor: 'yellow', padding: '8px', margin: 0, color: 'red', textAlign: "center" }}>*/}
                {/*        Zoom is not supported on this page. Please set your browser zoom level to 100%.*/}
                {/*    </h6>*/}
                {/*)}*/}
                <div className="horizontalMenucontainer">
                    <div className="horizontalMenucontainer">
                        {/*<div id="global-loader" >*/}
                        {/*    <img src={loaderImage} className="loader-img" alt="Loader" />*/}
                        {/*</div>*/}
                        <div className="page">
                            <NavHeader>
                            </NavHeader>
                            <div className="jumps-prevent" style={{ paddingTop: '64.3333px', borderBottomWidth: '3px', borderColor: '#393186', borderBottomStyle: "solid" }}></div>
                            <div className="main-content pt-0 hor-content">
                                <div className="main-container container">
                                    {this.props.children}
                                </div>
                            </div>
                            {/*<Footer/>*/}
                        </div>
                    </div>
                </div>
            </div>


            //<div>
            //  {/*<NavMenu />*/}
            //  {/*<Container>*/}
            //    {this.props.children}
            //  {/*</Container>*/}
            //</div>
        );
    }
}
